<template>
	<!-- Upload content -->
	<v-row align="start" justify="start">
		<v-col cols="12">
			<v-row>
				<v-col cols="8">
					<v-btn class="mr-2" to="/admin/functionality/add" v-if="listView"
						>Add</v-btn
					>
					<v-btn class="mr-2" to="/admin/functionality" v-else>Close</v-btn>
				</v-col>
			</v-row>
		</v-col>
		<v-col cols="12" v-if="listView">
			<h3 class="mb-4">Functionality</h3>
			<v-simple-table>
				<template v-slot:default>
					<thead>
						<tr>
							<th class="text-left">Title</th>
							<th class="text-left">Value</th>

							<th class="text-left"></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in sortedItems" :key="item.id">
							<td>{{ item.title }}</td>
							<td>{{ item.value }}</td>

							<td>
								<v-chip
									class="mr-2"
									:to="`/admin/functionality/show/${item.id}`"
								>
									Show
								</v-chip>
								<v-chip
									class="mr-2"
									:to="`/admin/functionality/edit/${item.id}`"
								>
									Edit
								</v-chip>
								<v-chip class="mr-2" @click="deleteItem(item.id)">
									Delete
								</v-chip>
							</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
		</v-col>
		<v-col cols="12" v-if="!listView">
			<router-view></router-view>
		</v-col>
	</v-row>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import lodash from 'lodash';
const fb = require('@/firebaseConfig.js');
import router from '@/router';

export default {
	name: 'AdminFunctionalityList',
	data() {
		return {
			collection: fb.functionalityCollection,
			items: null,
			returnRoute: 'AdminFunctionalityList',
		};
	},
	computed: {
		...mapState(['userProfile', 'currentUser']),
		listView() {
			return this.$route.name == 'AdminFunctionalityList' ? true : false;
		},
		containerWidth() {
			return this.listView ? '12' : '4';
		},
		cardWidth() {
			return this.listView ? '3' : '12';
		},
		sortedItems() {
			return lodash.orderBy(this.items, 'title', 'asc');
		},
	},
	created() {
		this.getItems();
	},
	methods: {
		getItems() {
			this.collection
				.where('project', '==', '3XmmgQzqtHdf3MQkYfq1')
				.onSnapshot((querySnapshot) => {
					let items = [];
					querySnapshot.forEach((doc) => {
						let post = doc.data();
						items.push(post);
					});
					this.items = items;
				});
		},
		deleteItem(id) {
			this.collection
				.doc(id)
				.delete()
				.then(() => {
					router.push({
						name: this.returnRoute,
					});
				})
				.catch((error) => {
					alert('Error removing document: ', error);
				});
		},
	},
};
</script>
